var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCertificationServiceMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 114,
    viewBox: "0 0 183 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7_10317)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.891,
    y: 33.251,
    width: 112.028,
    height: 71.1044,
    fill: "#6299FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6035 68.8013L131.315 33.1391L131.315 104.464L77.6035 68.8013Z",
    fill: "#8DB5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6041 68.8013L18.8922 33.1391L18.8922 104.464L72.6041 68.8013Z",
    fill: "#8DB5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1094 72.5351C79.6959 78.1578 70.1089 78.1578 63.6954 72.5351L18.8885 33.2523H130.916L86.1094 72.5351Z",
    fill: "#C4D8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.5482,
    y: 0.5,
    width: 84.9391,
    height: 108.982,
    rx: 3.5,
    fill: "#F3F3F3",
    stroke: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.102,
    y: 65.9844,
    width: 65.9873,
    height: 4.39915,
    rx: 2.19958,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.102,
    y: 54.2559,
    width: 65.9873,
    height: 4.39915,
    rx: 2.19958,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.102,
    y: 77.7178,
    width: 65.9873,
    height: 4.39915,
    rx: 2.19958,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.102,
    y: 89.4541,
    width: 46.9243,
    height: 4.39915,
    rx: 2.19958,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.721 21.9147L138.035 16.4297L125.151 21.9147V28.2749C125.151 31.951 124.834 35.8022 129.248 41.6372C131.578 44.7179 136.076 46.5776 138.035 47.1222C139.515 46.9277 143.307 45.5584 146.624 41.6372C150.721 36.7941 150.737 31.0952 150.721 28.2749V21.9147Z",
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.818 32.6369L136.229 36.6156L143.618 27.5215",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7_10317",
    x: 16.8885,
    y: 0,
    width: 166.099,
    height: 113.981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_10317"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_10317",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCertificationServiceMain);
export default __webpack_public_path__ + "static/media/IcCertificationServiceMain.389efd2565ddfaf382fe28d4abf9936e.svg";
export { ForwardRef as ReactComponent };